import { Tooltip, Typography } from "@mui/material";

import { RackSegment } from "./RackSegment";

/**
 * Build stamp — the version + short commit SHA the bundle was built
 * from, inlined at build time via Vite `define` (see vite.config.ts).
 *
 * Why it lives in the rack: it's the one-glance answer to "did my
 * deploy actually land?" — read the SHA off the live UI and compare it
 * to what you pushed. No backend round-trip, no guessing whether the
 * CDN served a stale bundle. Informational only (no click target), so
 * it stays calm at the end of the rack.
 */
export function VersionSegment() {
  const version = __APP_VERSION__;
  const sha = __GIT_SHA__;

  return (
    <Tooltip title={`Build v${version} · commit ${sha}`} placement="top" arrow>
      <span>
        <RackSegment label="BUILD" width={132}>
          <Typography
            variant="body2"
            sx={(t) => ({
              fontFamily: t.fonts.mono,
              fontSize: "0.75rem",
              fontWeight: 600,
              color: "text.secondary",
              letterSpacing: "0.02em",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            })}
          >
            v{version}
            <Typography
              component="span"
              sx={{
                fontFamily: (t) => t.fonts.mono,
                fontSize: "0.75rem",
                color: "text.disabled",
                ml: 0.75,
              }}
            >
              {sha}
            </Typography>
          </Typography>
        </RackSegment>
      </span>
    </Tooltip>
  );
}
